import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'

@Component
export class SetDefaultsMixin extends Vue {
  setDefaults(data: any, defaults: any = {}) {
    data = _.cloneDeep(data)
    defaults = _.cloneDeep(defaults)
    return _.defaultsDeep(data, defaults)
  }
}
